import React from "react"
import PropTypes from "prop-types"

const Processing = props => {
  Processing.propTypes = {
    message: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    progress: PropTypes.shape({
      current: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired
    })
  }

  const progress =
    (props.progress.current / props.progress.total) * 100.0 - 100.0

  return (
    <li className="p-4 flex-col flex-auto" data-status={props.status}>
      <header>
        <span className="message flex flex-row flex-auto text-sm text-gray-700 items-center">
          {props.message}
        </span>
      </header>
      <div className="progress flex-auto p-2">
        <span
          className="foreground bg-green-400"
          style={{ left: progress + "%" }}
        />
      </div>
    </li>
  )
}

export default Processing
